import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/services/auth.service';
import { LocalSessionService } from 'src/services/local-session.service';
import Swal from 'sweetalert2';
import { RouteHelperService } from 'src/services/route-helper.service';

interface UserVehicle {
  id?: string;
  user_id?: string;
  owner_id?: string;
  plate_number: string;
  vehicle_type: string;
  vehicle_model?: string;
  vehicle_color?: string;
  vehicle_type_custom_name?: string;
  vin_number?: string;
  code?: string;
  latest_log_id?: string;
  previous_owner_id?: string | null;
  deleted?: boolean;
  
  // Owner information (for registration forms)
  owner_full_name?: string;
  owner_contact_number?: string;
  owner_email?: string;
  owner_address?: string;
  driver_license_number?: string;
  license_expiry_date?: string;
  
  // Document files/URLs
  cr_document?: File | string;
  or_document?: File | string;
  government_id?: File | string;
  drivers_license?: File[] | string[];
  insurance_document?: File | string;
  
  // Timestamps
  date_created?: Date | any;
  date_registered?: Date | any;
  updated_at?: Date | any;
  updatedAt?: Date | any;
  
  // Verification status
  verification_status?: 'pending' | 'verified' | 'rejected' | string;
  rejection_reason?: string;
  verified_by?: string;
  verified_date?: Date | any;
}

@Component({
  selector: 'app-vehicle-registration',
  templateUrl: './vehicle-registration.component.html',
  styleUrls: ['./vehicle-registration.component.css']
})
export class VehicleRegistrationComponent implements OnInit {

  user: any;
  showWizard: boolean = true;
  demoMode: boolean = true; // Enable demo mode for simplified flow

  constructor(
    private authService: AuthService,
    private localSessionService: LocalSessionService,
    private router: Router,
    public routeHelper: RouteHelperService
  ) { }

  ngOnInit(): void {
    // Validate user authentication
    if (!this.validateUserAuthentication()) {
      return;
    }
  }

  private validateUserAuthentication(): boolean {
    // Check for user in localStorage
    this.user = JSON.parse(localStorage.getItem('user') || '{}');
    if (!this.user || !this.user.uid) {
      console.log('No authenticated user found');
      this.router.navigate([this.routeHelper.getRoutes().auth]);
      return false;
    }
    
    // Validate local session
    const currentSession = this.localSessionService.getCurrentSession();
    if (!currentSession || currentSession.uid !== this.user.uid) {
      console.log('Invalid or expired session');
      this.localSessionService.clearSession();
      localStorage.removeItem('user');
      this.router.navigate([this.routeHelper.getRoutes().auth]);
      return false;
    }
    
    // Update last access time
    this.localSessionService.updateLastLogin();
    
    return true;
  }

  onRegistrationSuccess(vehicle: UserVehicle) {
    // Show success message for demo mode
    if (this.demoMode) {
      Swal.fire({
        title: 'Success!',
        text: 'Vehicle registered successfully! You can now use this vehicle for parking.',
        icon: 'success',
        confirmButtonText: 'Continue to Dashboard',
        confirmButtonColor: '#2563eb',
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then((result) => {
        // Redirect to dashboard after user confirms
        this.router.navigate([this.routeHelper.getRoutes().dashboard]);
      });
    } else {
      // Redirect to dashboard after successful registration
      this.router.navigate([this.routeHelper.getRoutes().dashboard]);
    }
  }

  onRegistrationCancel() {
    // Signal that vehicle checking should be cancelled
    localStorage.setItem('cancelVehicleCheck', 'true');
    
    // Allow user to cancel and go to dashboard (they can register later)
    this.router.navigate([this.routeHelper.getRoutes().dashboard]);
  }

  onRegistrationError(error: string) {
    console.error('Vehicle registration error:', error);
    // Could show an error message or handle the error as needed
  }
}